import React from 'react';
import LegalDocumentPage from './LegalDocumentPage.js';
import { getPrivacyPolicySections } from './legalContent.js';

function PrivacyPolicyPage({ isMobile }) {
  return <LegalDocumentPage isMobile={isMobile} content={getPrivacyPolicySections()} />;
}

export default PrivacyPolicyPage;